<template>
    <div>
        <table class="table" :class="type" v-if="rows && rows.length">
            <thead>
                <tr>
                    <th v-if="selectable">
                        <input type="checkbox" :checked="allDisplayItemsSelected" @click.stop="selectAllRows">
                    </th>
                    <th v-if="hasPrefix"></th>
                    <th v-for="column in columns" v-show="column.selected" @click="sortBy(column)">
                        {{ column.title }}
                        <i v-show="column.ascending" class="far fa-angle-up ml-1"></i>
                        <i v-show="column.descending" class="far fa-angle-down ml-1"></i>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, rowIndex) in rows" :key="row.id"
                    :class="{'table-danger': row.danger, 'table-opacity': row.opacity}" :id="'row-' + row.id">
                    <td class="position-relative grid-corner-cell" v-if="selectable">
                        <input :disabled="row.disabled" v-if="!row.lockIcon" type="checkbox" v-model="row.selected" @change="selectRow(row)">
                        <img :src="getCornerSrc(row.cornerImage)" v-if="row.cornerImage" :id="'row-corner-' + row.id">
                        <i class="fa fa-lock" aria-hidden="true" v-if="row.lockIcon" :id="'row-corner-' + row.id"></i>
                        <b-tooltip :delay="400" v-if="row.cornerMessage" :target="'row-corner-' + row.id">
                            <span class="small">{{row.cornerMessage}}</span>
                        </b-tooltip>
                        <b-popover v-if="row.hover && row.hover.message" :target="'row-' + row.id" placement="top"
                                   :title="row.hover.title" triggers="hover">
                            <span class="small">{{row.hover.message}}</span>
                        </b-popover>
                    </td>
                    <td v-if="hasPrefix">
                        <a v-if="getPrefix(row).link" :href="getPrefix(row).link">
                            {{ getPrefix(row).value }}
                        </a>
                        <a v-else-if="getPrefix(row).clickable" @click="rowClick(row)" class="text-primary">
                            {{ getPrefix(row).value }}
                        </a>
                        <span v-else-if="getPrefix(row).value">
                            {{ getPrefix(row).value }}
                        </span>
                    </td>
                    <td v-for="(column, columnIndex) in columns" :key="column.key"
                        v-show="column.selected" :id="getCellIdentifier(rowIndex, column)">
                            <a v-if="getCell(row, column).link" :href="getCell(row, column).link">
                                {{ getCell(row, column).value }}
                            </a>
                            <a v-else-if="column.clickable" @click="cellClick(row, column)" class="text-primary">
                                {{ getCell(row, column).value }}
                            </a>
                            <span v-else-if="getCell(row, column).value">
                                {{ getCell(row, column).value }}
                            </span>

                            <i v-if="getCellIcon(row, column)" :class="getCellIcon(row, column)"></i>
                            <b-tooltip :delay="400" v-if="getCellTooltip(row, column)" :target="getCellIdentifier(rowIndex, column)">
                                <a v-if="getCell(row, column).tooltipLink" target="_blank"
                                   class="small" :href="'//' + getCellTooltip(row, column)">
                                    {{getCellTooltip(row, column)}}
                                </a>
                                <span class="small" v-else>{{getCellTooltip(row, column)}}</span>
                            </b-tooltip>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    const EVENTS = {
        CELL_CLICK: 'cellClick',
        ROW_CLICK: 'rowClick',
        SORT_BY: 'sortBy',
        ON_ITEM_CHECK_CHANGE: 'onItemCheckChange',  // TODO: rename without "on"
    };

    export default {
        name: 'BootstrapGrid',
        props: {
            columns: Array,
            rows: Array,
            type: String,
            allDisplayItemsSelected: Boolean,
            selectable: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            hasPrefix() {
                return this.rows.some(row => !!row.prefix);
            }
        },
        methods: {
            getRowTooltip(row) {
                return row.tooltip;
            },
            getCell(row, column) {
                return row.data[column.key] || {};
            },
            getCellIcon(row, column) {
                return this.getCell(row, column).icon;
            },
            isSuccessCell(row, column) {
                return this.getCell(row, column).success;
            },
            getCellTooltip(row, column) {
                return this.getCell(row, column).tooltip;
            },
            getCellIdentifier(rowIndex, column) { //id used as target for tooltip
                return `${column.key}-${rowIndex}`;
            },
            getPrefix(row) {
                return row.prefix || {};
            },
            selectAllRows(event) {
                this.$emit(EVENTS.ON_ITEM_CHECK_CHANGE, {checked: event.target.checked, data: this.rows});
            },
            selectRow(row, event) {
                this.$emit(EVENTS.ON_ITEM_CHECK_CHANGE, {checked: row.selected, data: row});
            },
            getCornerSrc(path) {
                return`/assets/img/corners/${path}.png`;
            },
            sortBy(column) {
                let queryString = '';
                // reset all rows
                this.columns.filter(col => col.key !== column.key).forEach(col => {
                    col.descending = false;
                    col.ascending  = false;
                });
                // set sorting on clicked column
                if (column.ascending) {
                    column.ascending  = false;
                    column.descending = true;
                    queryString = `-${column.key}`;
                } else if (column.descending) {
                    column.descending = false;
                } else {
                    column.ascending = true;
                    queryString = column.key;
                }

                this.$emit(EVENTS.SORT_BY, column, column.ascending, column.descending);
            },
            cellClick(row, column) {
                this.$emit(EVENTS.CELL_CLICK, this.getCell(row, column), row, column);
            },
            rowClick(row) {
                this.$emit(EVENTS.ROW_CLICK, row);
            }
        }
    };
</script>
